module.exports = __webpack_public_path__ + "img/143ne.706ec01a.svg";